<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.querySn" class="input-with-select" size="small">
                        <el-select v-model="params.querySnType" slot="prepend" placeholder="请选择">
                            <el-option label="订单编号" :value="1"></el-option>
							<el-option label="用户ID" :value="5"></el-option>
                            <el-option label="支付平台交易号" :value="2"></el-option>
                            <el-option label="银行交易号" :value="3"></el-option>
							<el-option label="银行提现号" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>				
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="params.queryTimeType" slot="prepend" placeholder="请选择">
				                <el-option label="下单时间" :value="1"></el-option>
				                <el-option label="支付时间" :value="2"></el-option>
				                <el-option label="退订时间" :value="3"></el-option>
				                <el-option label="退款时间" :value="4"></el-option>
								<el-option label="提现时间" :value="5"></el-option>
				            </el-select>
				        </el-input>
				        <el-date-picker
				            v-model="datetimerange"
				            type="datetimerange"
				            start-placeholder="开始日期"
				            end-placeholder="结束日期"
				            class="fl"
				            size="small"
				            value-format="yyyy-MM-dd HH:mm:ss"
				            :default-time="['00:00:00', '23:59:59']"
				            unlink-panels
				            >
				        </el-date-picker>
				    </div>
				</el-col>				
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">				    
					<el-select v-model="params.paymentStatus" placeholder="请选择" size="small">
						<el-option label="不限制支付状态" :value="-1"></el-option>
						<el-option label="仅看未支付的" :value="1"></el-option>
						<el-option label="仅看已支付的" :value="2"></el-option>
					</el-select>				   
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.orderStatus" placeholder="请选择" size="small">
				        <el-option label="不限制订单状态" :value="-1"></el-option>
				        <el-option label="仅看待支付的" :value="0"></el-option>
				        <el-option label="仅看待确认的" :value="2"></el-option>
				        <el-option label="仅看已确认的" :value="3"></el-option>
				        <el-option label="仅看已过期的" :value="11"></el-option>
				        <el-option label="仅看退订中的" :value="8"></el-option>
				        <el-option label="仅看已退订的" :value="9"></el-option>				        
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.withdrawalStatus" placeholder="请选择" size="small">
				        <el-option label="不限制提现状态" :value="-1"></el-option>
				        <el-option label="仅看未提现的" :value="0"></el-option>
				        <el-option label="仅看已提现的" :value="1"></el-option>			        
				    </el-select>
				</el-col>				
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="sn" label="订单编号" min-width="150"></el-table-column>
                <el-table-column prop="totalAmount" label="订单总金额" min-width="100" ></el-table-column>
                <el-table-column prop="createUser" label="下单用户ID" min-width="100"></el-table-column>
                <el-table-column prop="contacterMobile" label="下单用户电话" min-width="100"></el-table-column>
                <el-table-column prop="payPlatform" label="支付平台" min-width="100"></el-table-column>
                <el-table-column prop="paymentStatus" label="支付状态"></el-table-column>
				<el-table-column prop="orderStatus" label="订单状态"></el-table-column>				
				<el-table-column prop="createTime" label="下单时间" min-width="140"></el-table-column>
				<el-table-column prop="paidTime" label="支付时间" min-width="140"></el-table-column>
				<el-table-column prop="unsubscribeTime" label="退订时间" min-width="140"></el-table-column>
				<el-table-column prop="refundTime" label="退款时间" min-width="140"></el-table-column>
				<el-table-column prop="ratePlanId" label="价格计划ID" min-width="300"></el-table-column>				
				<el-table-column prop="payPlatformTradeNo" label="支付平台交易号" min-width="200"></el-table-column>
				<el-table-column prop="depositId" label="银行交易号" min-width="200"></el-table-column>
				<el-table-column prop="withdrawalTradeNo" label="银行提现号" min-width="100"></el-table-column>
				<el-table-column prop="withdrawalTime" label="提现时间" min-width="140"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$refs.hotelDetails.show(scope.row.id)"
                            >查看入住信息</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <hotel-details ref="hotelDetails"></hotel-details>
    </div>
</template>

<script>
import hotelDetails from './components/hotelDeatils.vue'
const defaultParams = {
    pageNo:1,
	querySn:'',
    querySnType: 1,
	queryTimeType:1,
	paymentStatus:-1,
	orderStatus:-1,
	withdrawalStatus:-1,
	endTime:'',
	startTime:'',
}
export default {
    components: {hotelDetails},
    data(){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
				startTime: this.$route.query.startTime || '',
				endTime: this.$route.query.endTime || '',
				queryTimeType: parseInt(this.$route.query.queryTimeType || 1),
				querySnType: parseInt(this.$route.query.querySnType || 1),
				querySn: this.$route.query.querySn || '',
            },
            listLoading: false,
			datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
           
        }
    },
    created(){
       
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
			this.params.startTime = this.datetimerange && this.datetimerange[0] || null;
			this.params.endTime = this.datetimerange && this.datetimerange[1] || null;
            this.$request({
                url: "/hotelOrder/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.areaCode = [];
			this.datetimerange = []			
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        
    }
}
</script>

<style lang="scss" scoped>

</style>